import Component from '@glimmer/component';
import UiCard from 'garaje/components/ui/card';
import UiPill from 'garaje/components/ui-pill';
import LOCALES, { type LocaleKey } from 'garaje/utils/locale-options';

interface QuestionnaireFormTranslatableContentSignature {
  Args: {
    defaultLocale: LocaleKey;
    selectedLocale: LocaleKey;
    showLanguagePill: boolean;
  };
  Blocks: {
    original: [];
    selected: [translating: boolean, defaultLanguageName: string];
  };
}

export default class QuestionnaireFormTranslatableContent extends Component<QuestionnaireFormTranslatableContentSignature> {
  get defaultLanguageName(): string {
    const defaultLocale = this.args.defaultLocale;
    const defaultLocaleOption = LOCALES.find((locale) => locale.value === defaultLocale)!;
    return defaultLocaleOption.label;
  }

  get isTranslating(): boolean {
    return this.args.selectedLocale !== this.args.defaultLocale;
  }

  <template>
    {{#if this.isTranslating}}
      <UiCard @border={{true}} class="p-0 mr-2">
        <div class="bg-carbon-5 mb-2 py-2">
          {{#if @showLanguagePill}}
            <UiPill @fill="grayLighter" data-test-original-language-pill>{{this.defaultLanguageName}}</UiPill>
          {{/if}}

          {{yield to="original"}}
        </div>

        <div class="px-2">
          {{yield this.isTranslating this.defaultLanguageName to="selected"}}
        </div>
      </UiCard>
    {{else}}
      {{yield false this.defaultLanguageName to="selected"}}
    {{/if}}
  </template>
}
